export const JobStatus = {
  Waiting: '0',
  // Accepting: '1', ※ネクシモ版では廃止
  Creating: '2',
  Complete: '3',
  Cancel: '4',
  Error: '9'
} as const
export type JobStatus = typeof JobStatus[keyof typeof JobStatus]

export const JobIdMaxDigits: number = 10
